import { FC, HTMLAttributes } from "react";
import Image from "next/image";
import Link from "next/link";
import clsx from "clsx";
import { useDisclosure } from "@mantine/hooks";
import { Squash as Hamburger } from "hamburger-react";

import HeaderMainMenuDrawer from "./HeaderMainMenuDrawer";

import logo from "@/assets/images/branding/logo.svg";

import { IHeaderMenuItem } from "./DesktopHeader";

// ----------------------------------------------------------------------------------------------

export type IMobileHeaderProps = HTMLAttributes<HTMLDivElement> & {
  mainMenu?: (IHeaderMenuItem | undefined)[];
};

const MobileHeader: FC<IMobileHeaderProps> = (props) => {
  const { mainMenu, className, ...other } = props;

  const [mainMenuOpened, setMainMenu] = useDisclosure(false);
  const [subMenuOpened, setSubMenu] = useDisclosure(false);

  return (
    <div
      className={clsx(
        "mx-auto flex h-full max-w-screen-xl flex-wrap items-center justify-between",
        className,
      )}
      {...other}
    >
      <Link
        href="/"
        aria-label="Certbar Security home"
        className="flex items-center"
        prefetch={true}
        onClick={() => {
          setMainMenu.close();
          setSubMenu.close();
        }}
      >
        <Image
          src={logo.src}
          className="mr-3 h-10 sm:h-9"
          alt="Certbar Security"
          width={150}
          height={35}
        />
      </Link>

      <div className="flex items-center gap-3">
        <Hamburger
          toggled={mainMenuOpened}
          toggle={(opened) => {
            if (opened) {
              setMainMenu.open();
            } else {
              setMainMenu.close();
              setSubMenu.close();
            }
          }}
          size={24}
          color="#252C37"
          label="Toggle main menu"
          rounded
        />
      </div>

      <HeaderMainMenuDrawer
        mainMenuOpened={mainMenuOpened}
        subMenuOpened={subMenuOpened}
        setMainMenu={setMainMenu}
        setSubMenu={setSubMenu}
        mainMenu={mainMenu}
      />
    </div>
  );
};

export default MobileHeader;
